import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import tr from '../localization/translate';

import s from './DetailsItem.scss';

/* eslint-disable react/prop-types */
export function DetailsTitle({ children, className }) {
  return (
    <dt className={`text break_word ${s.title} ${className}`}>
      { children }
    </dt>
  );
}


function innerContent(children, link) {
  if (link) {
    return (
      <a href={link} target="_blank" rel="noopener noreferrer">{ children }</a>
    );
  }

  return children || tr('matching.no_entry');
}


function DetailsContent({
  children,
  className,
  link,
  complexContent
}) {
  const content = innerContent(children, link);

  if (complexContent) {
    return (
      <dd className={className} styleName="content">
        { content }
      </dd>
    );
  }

  return (
    <dd
      className={classNames(
        'heavy_text',
        s.content,
        className,
        { [s.no_entry]: !children }
      )}
    >
      { content }
    </dd>
  );
}
/* eslint-enable react/prop-types */


export default function DetailsItem({
  children,
  className,
  contentClassName,
  link,
  title,
  titleClassName,
  complexContent
}) {
  return (
    <div className={`${s.section} ${className}`}>
      <DetailsTitle className={titleClassName}>
        { title }
      </DetailsTitle>

      <DetailsContent
        className={contentClassName}
        link={link}
        complexContent={complexContent}
      >
        { children }
      </DetailsContent>
    </div>
  );
}

DetailsItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  link: PropTypes.string,
  title: PropTypes.string.isRequired,
  titleClassName: PropTypes.string,
  complexContent: PropTypes.bool
};

DetailsItem.defaultProps = {
  children: null,
  className: '',
  contentClassName: '',
  link: '',
  titleClassName: '',
  complexContent: false
};

export const SectionDividerClass = Object.freeze({
  NORMAL: '',
  BOLD: s.bold_divider
});

export const condensedContainerClass = s.condensed_container;
